import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { WatchPage } from '@/app/watch/WatchPage';

export const Route = createFileRoute('/_app/cursos/_painel/$slug/assistir')({
  validateSearch: z.object({
    aula: z.string().optional().catch(undefined),
    /** Segundo de início, de um link compartilhado ("começar em 3:12"). */
    t: z.coerce.number().int().min(0).optional().catch(undefined),
  }),
  component: function WatchRoute() {
    const { slug } = Route.useParams();
    const { aula, t } = Route.useSearch();
    return <WatchPage slug={slug} lessonId={aula} startAt={t} />;
  },
});
